/* eslint-disable @typescript-eslint/no-explicit-any */

import { cn } from "@/lib/utils";

type DocumentTableCellProp = {
  data: any;
  keyValue: string;
  parentKey?: string;
  isHeader?: boolean;
  className?: string;
  textType?: string;
  feedback?: boolean;
};
export const AuditTableCell = ({
  data,
  isHeader,
  feedback,
}: DocumentTableCellProp) => {
  return (
    <div
      className={cn(
        "table-cell text-[14px] py-[8px] min-w-[200px] px-3",
        isHeader
          ? "table-cell bg-gray-100 font-semibold relative"
          : "outline-buttonColor relative text-[rgb(71,85,105)] py-4 px-3",
        feedback ? "bg-green-50 border border-green-100" : ""
      )}
    >
      {data === "" ? <span className="opacity-0">-</span> : data}
    </div>
  );
};
